import { render, staticRenderFns } from "./forgot-password.component.vue?vue&type=template&id=4fdf554c"
import script from "./forgot-password.component.ts?vue&type=script&lang=ts&external"
export * from "./forgot-password.component.ts?vue&type=script&lang=ts&external"
import style0 from "./forgot-password.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports